function onBtnScrollClick() {
  document.querySelector('.header').scrollIntoView({
    behavior: 'smooth',
  });
}

export { onBtnScrollClick };
